"use client";

import LocaleLink from "@/app/_components/LocaleLink";
import { useTranslation } from "@/lib/i18n";
import { cn } from "@/lib/utils";
import { usePathname } from "next/navigation";
import React from "react";

type BlogSideNavProps = {
  items: {
    label: string;
    href: string;
  }[];
  lng: string;
};

const BlogSideNav: React.FC<BlogSideNavProps> = ({ items, lng }) => {
  const pathname = usePathname();
  const { t } = useTranslation({ ns: "blog", lng });

  return (
    <div className="border-r-1 border-neutral-100 pr-8">
      <div className="sticky top-[104px]">
        <div className="hidden flex-col gap-8  md:flex">
          <p className="text-xl">{t("heading")}</p>

          <div className="h-px w-full bg-neutral-100"></div>
          <div className="relative hidden flex-col gap-2 md:flex">
            {[{ label: "All Posts", href: "/blog" }, ...items].map((item) => (
              <LocaleLink
                key={item.label}
                href={item.href}
                className={cn(
                  " text-base font-normal text-neutral-500 transition-colors duration-300 hover:text-neutral-900",
                  "flex items-center gap-1",
                  pathname.includes(item.href) && "text-neutral-900",
                )}
                lng={lng}
              >
                {item.label}
              </LocaleLink>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogSideNav;
